import { parse as parseYaml } from 'yaml';
const stripQuizDelimiters = (content)=>{
    if (!content) return '';
    const trimmed = content.trim();
    if (!trimmed.startsWith(':::')) {
        return trimmed;
    }
    const lines = trimmed.split(/\r?\n/);
    if (lines.length && lines[0].trim().startsWith(':::')) {
        lines.shift();
    }
    if (lines.length && lines[lines.length - 1].trim() === ':::') {
        lines.pop();
    }
    return lines.join('\n').trim();
};
const normaliseString = (value, fallback = '')=>{
    if (typeof value === 'string') {
        return value.trim();
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
        return String(value);
    }
    return fallback;
};
const normaliseStringArray = (value)=>{
    if (Array.isArray(value)) {
        return value.map((item)=>normaliseString(item)).filter((item)=>item.length > 0);
    }
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
            return trimmed.slice(1, -1).split(',').map((entry)=>normaliseString(entry)).filter((entry)=>entry.length > 0);
        }
        if (trimmed.length > 0) {
            return [
                trimmed
            ];
        }
    }
    return undefined;
};
const toInteractiveQuizQuestion = (raw, index)=>{
    if (!raw || typeof raw !== 'object') {
        return null;
    }
    const id = normaliseString(raw.id, `quiz-${index}`) || `quiz-${index}`;
    const question = normaliseString(raw.question, '문항 내용을 입력하세요.');
    const explanation = normaliseString(raw.explanation);
    const rawOptions = normaliseStringArray(raw.options);
    const baseType = normaliseString(raw.type, 'multiple-choice').toLowerCase();
    const allowedTypes = [
        'multiple-choice',
        'multiple-answer',
        'short-answer',
        'essay'
    ];
    const type = allowedTypes.includes(baseType) ? baseType : 'multiple-choice';
    const questionData = {
        id,
        type,
        question,
        options: rawOptions,
        explanation: explanation || undefined
    };
    if (type === 'multiple-choice') {
        if (typeof raw.answerIndex === 'number') {
            questionData.answerIndex = raw.answerIndex;
        } else if (rawOptions && typeof raw.answer !== 'undefined') {
            const answerText = normaliseString(raw.answer);
            const indexInOptions = rawOptions.findIndex((option)=>option === answerText);
            if (indexInOptions >= 0) {
                questionData.answerIndex = indexInOptions;
            }
        }
    } else if (type === 'multiple-answer') {
        const answers = normaliseStringArray(raw.answer);
        questionData.answer = answers && answers.length > 0 ? answers : undefined;
    } else if (type === 'short-answer') {
        const answers = normaliseStringArray(raw.answer);
        if (answers && answers.length) {
            questionData.answer = answers;
        } else if (raw.answer) {
            const value = normaliseString(raw.answer);
            if (value) {
                questionData.answer = value;
            }
        }
    }
    if (type === 'multiple-choice' && (!questionData.options || questionData.options.length === 0)) {
        return null;
    }
    return questionData;
};
export const parseQuizBlockContent = (content)=>{
    const yamlSource = stripQuizDelimiters(content);
    if (!yamlSource) {
        return [];
    }
    try {
        const parsed = parseYaml(yamlSource);
        const items = Array.isArray(parsed) ? parsed : [
            parsed
        ];
        return items.map((item, index)=>toInteractiveQuizQuestion(item, index)).filter((item)=>Boolean(item));
    } catch (error) {
        console.warn('[quizBlockParser] YAML 파싱 실패:', error);
        return [];
    }
};
const QUIZ_BLOCK_REGEX = /:::quiz[\s\S]*?:::/g;
export const splitMarkdownWithQuizBlocks = (markdown)=>{
    if (!markdown) {
        return [];
    }
    const segments = [];
    let lastIndex = 0;
    const matches = markdown.matchAll(QUIZ_BLOCK_REGEX);
    for (const match of matches){
        if (!match[0]) {
            continue;
        }
        const matchIndex = match.index ?? 0;
        if (matchIndex > lastIndex) {
            segments.push({
                type: 'markdown',
                content: markdown.slice(lastIndex, matchIndex)
            });
        }
        const rawBlock = match[0];
        segments.push({
            type: 'quiz',
            raw: rawBlock,
            questions: parseQuizBlockContent(rawBlock)
        });
        lastIndex = matchIndex + rawBlock.length;
    }
    if (lastIndex < markdown.length) {
        segments.push({
            type: 'markdown',
            content: markdown.slice(lastIndex)
        });
    }
    return segments.filter((segment)=>{
        if (segment.type === 'markdown') {
            return segment.content.trim().length > 0;
        }
        return true;
    });
};
